module.exports = __webpack_public_path__ + "src/img/tencentIcon.4b67ba6c.png";